import { useTranslation } from 'react-i18next';

import { IconChevronDown } from '@pentabd/icons';
import { ProgressSteps, Text } from '@pentabd/ui';

export const ApprovalWorkFlow = () => {
  const { t } = useTranslation();

  return (
    <div className="col-lg-10">
      <Text weight="semibold" size="lg" color="dark" className="mb-8 d-block">
        {t('RETIREMENT.APPROVAL_WORKFLOW')}
      </Text>
      <div className="px-10 py-9 mb-10 d-md-flex gap-6 bg-primary-25 rounded-6 approval-border position-relative">
        <div className="d-flex flex-column py-4 shrink-0">
          <Text size="xs" color="subtitle1" weight="medium">
            02 Apr, 2023
          </Text>
          <Text
            size="xs"
            color="subtitle3"
            weight="medium"
            className="text-end"
          >
            10:50 am
          </Text>
        </div>
        <ProgressSteps
          mode="vr"
          size="sm"
          current={2}
          items={[
            {
              title: 'Approved from ______',
              subtitle: 'Show if there are any comments',
            },
            {
              title: 'In Progress',
              subtitle: 'Name of Dependant',
            },
            {
              title: 'Pending',
              subtitle: '',
            },
          ]}
        />
        <div className="d-flex gap-4 approval-accordion-btn pointer">
          <Text size="sm" color="subtitle2">
            Hide
          </Text>
          <IconChevronDown size={20} fill="subtitle2" />
        </div>
      </div>
    </div>
  );
};
